import React, {FC} from 'react'
import StatusButton from '../StatusButton'

interface ShipmentStatusButtonProps {
  syncStatus: string
  syncMessage?: string
}

/** Shipment sync column — uses shared StatusButton display rules for all API statuses. */
const ShipmentStatusButton: FC<ShipmentStatusButtonProps> = ({syncStatus, syncMessage}) => (
  <StatusButton syncStatus={syncStatus} syncMessage={syncMessage} />
)

export default ShipmentStatusButton
